"use client"
import { useLayoutEffect } from "react";
import { parseProgramHash } from "src/lib/programHash";

//#region [Component]
/**
 * Links from the program carry the program state in the hash (#dd.MM.yyyy or #all, optionally with filters).
 * Since Next 16.3, a hash without a matching element skips Next's scroll-to-top, so the
 * film page would open at the program page's scroll position. Scroll to the top ourselves.
 */
export default function ScrollToTopOnDateHash() {
    useLayoutEffect(() => {
        if (isProgramDateHash(window.location.hash)) {
            window.scrollTo(0, 0);
        }
    }, []);

    return null;
}
//#endregion

//#region [Other]
export function isProgramDateHash(hash: string): boolean {
    const { date, cinemas, genres } = parseProgramHash(hash);
    return date !== null || cinemas !== null || genres !== null;
}
//#endregion
